import React from 'react';
type CycleMarkProps = {
  className?: string;
};

/**
 * Copo de hielo dentro del ciclo congelado → cosecha — el motivo de la
 * identidad DPS66. Hereda el color vía `currentColor`.
 */
export function CycleMark({
  className
}: CycleMarkProps) {
  return <svg viewBox="0 0 240 240" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={className} data-id="element-78" data-mp="37ftfimsrrt4v">
      <circle cx="120" cy="120" r="104" strokeDasharray="3 9" data-id="element-79" data-mp="90aejz7y4165" />
      <path d="M120 36a84 84 0 0 1 84 84" data-id="element-80" data-mp="8ziqraklb7qf" />
      <path d="M196 112l8 10 8-10" data-id="element-81" data-mp="3q8ns5a2x795x" />
      <path d="M120 204a84 84 0 0 1-84-84" data-id="element-82" data-mp="3q7m7qf00labj" />
      <path d="M44 128l-8-10-8 10" data-id="element-83" data-mp="3v7iciggjd5s5" />
      <circle cx="120" cy="120" r="58" data-id="element-84" data-mp="3v6gzw7jvgb8b" />
      <path d="M120 78v84M83.6 99l72.8 42M83.6 141l72.8-42" data-id="element-85" data-mp="3v9lcntbekfal" />
      <path d="M110 86l10 10 10-10M110 154l10-10 10 10" data-id="element-86" data-mp="2es79z8zzeefd" />
      <path d="M90 92l13 4-4 13M150 148l-13-4 4-13" data-id="element-87" data-mp="2jsbv5cbu3xbx" />
      <path d="M90 148l13-4-4-13M150 92l-13 4 4 13" data-id="element-88" data-mp="2jt4v9ugafol3" />
    </svg>;
}